module.exports = __webpack_public_path__ + "static/media/info-countryhouse.55fad2c1.jpg";